import { Component, Input, OnInit } from "@angular/core";
import { DownloadModalService } from "./download-modal.service";
import { ModalAssets } from "./download-modal.constants";

@Component({
  selector: "app-download-modal",
  templateUrl: "./download-modal.component.html",
  styleUrls: ["./download-modal.component.scss"]
})
export class DownloadModalComponent implements OnInit {
  show = false;
  assets: ModalAssets;

  @Input() forceShow = false;

  constructor(private downloadService: DownloadModalService) {}

  ngOnInit(): void {
    if (this.forceShow) {
      this.assets = this.downloadService.getAssetsForModal();
      this.open();
      return;
    }

    if (this.downloadService.shouldShowModal()) {
      this.assets = this.downloadService.getAssetsForModal();
      this.open();
    }
  }

  open(): void {
    this.show = true;
  }

  close(): void {
    this.show = false;
    this.downloadService.markShown();
  }

  onDownloadClick(): void {
    if (!this.assets || !this.assets.storeLink) {
      return;
    }
    window.open(this.assets.storeLink, "_blank");
  }
}
